import { $t } from "../../../helpers/translator";
import Menu from "../../../components/miscellaneous/Menu/Menu";
import { FaClinicMedical, FaChartBar, FaSitemap, FaTools, FaCog, FaUserFriends } from 'react-icons/fa';
import machineWhite from '../../../assets/alma-icons/machineWhite.png'
import handleWhite from '../../../assets/alma-icons/handleWhite.png'

const AdminMenu = () => {
    const items = [
        { name: $t('global.menu.dashboard'), icon: <FaChartBar />, path: '/', pathIncludes: '/dashboard' },
        { name: $t('global.menu.distributors'), icon: <FaSitemap />, path: '/distributors', pathIncludes: '/distributor/' },
        { name: $t('global.menu.clinicsAndChains'), icon: <FaClinicMedical />, path: '/clinics', pathIncludes: '/clinic/' },
        { name: $t('global.menu.users'), icon: <FaUserFriends />, path: '/users', pathIncludes: '/users/' },
        {
            name: $t('global.menu.equipment'), icon: <FaCog />, path: null, children: [
                { name: $t('global.menu.platforms'), icon: machineWhite, path: '/equipment/platforms', pathIncludes: '/platform/' },
                { name: $t('global.menu.applicators'), icon: handleWhite, path: '/equipment/applicators', pathIncludes: '/applicator/' },
            ]
        },
        { name: $t('global.menu.service'), icon: <FaTools />, path: '/service', exact: true },
    ]

    return (
        <Menu items={ items } />
    )
};

export default AdminMenu;
